var React = require('react');

function ArrowCircle2 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25","cy":"25","r":"24.25","stroke":"white","strokeWidth":"1.5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 21.1276L21.0972 20.0205L28.3506 27.3519L28.4486 20L30 20.0203L29.8673 30L20.0915 29.9998L20.0915 28.434L27.2285 28.434L20 21.1276Z","fill":"white","key":1})]);
}

ArrowCircle2.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ArrowCircle2;

ArrowCircle2.default = ArrowCircle2;
